"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFilter = void 0;
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _react = require("react");
var _bannerProductListingContext = require("../../../contexts/bannerProductListingContext");
var _useDelayedLoading = require("../../../utils/useDelayedLoading");
// Just for encapsulation of logic for filter component on PLP
const useFilter = (param)=>{
    let { initialValue, loadData, appliedFacets, setAppliedFacets } = param;
    const { getFacets } = (0, _bannerProductListingContext.useBannerProductListingContext)();
    // this is value for filter component
    const [facets, setFacets] = (0, _react.useState)(initialValue);
    const [loading, setLoading] = (0, _react.useState)(false);
    const { isLoading } = (0, _useDelayedLoading.useDelayedLoading)({
        loading
    });
    /**
   * Used for displaying selected facets in filter container
   * It is different than appliedFacets, because appliedFacets can contain facets that are not selected
   */ const selectedFacets = (0, _react.useMemo)(()=>appliedFacets.flatMap((facet)=>facet.items.filter((item)=>item.selected).map((item)=>({
                    ...item,
                    category: facet.key
                }))), [
        appliedFacets
    ]);
    const onFilterChange = (0, _react.useCallback)(async (values)=>{
        setFacets(values);
        setLoading(true);
        const newFacets = await getFacets(values);
        setFacets(newFacets);
        setLoading(false);
    }, [
        getFacets
    ]);
    const onFilterApply = (0, _react.useCallback)(async (value)=>{
        setAppliedFacets(value);
        loadData();
    }, [
        loadData,
        setAppliedFacets
    ]);
    const onClear = (0, _react.useCallback)(async ()=>{
        const updatedValue = appliedFacets.map((facet)=>({
                ...facet,
                items: facet.items.map((item)=>({
                        ...item,
                        selected: false
                    }))
            }));
        setAppliedFacets(updatedValue);
        await onFilterChange(updatedValue);
        loadData();
    }, [
        onFilterChange,
        loadData,
        appliedFacets,
        setAppliedFacets
    ]);
    const onFilterClose = (0, _react.useCallback)(async ()=>{
        /**
     * When user clicks on close button, we need to reset filter facets to currently applied facets.
     * This is because user can change filter facets, but not apply them.
     */ if (!(0, _lodash.default)(facets, appliedFacets)) {
            await onFilterChange(appliedFacets);
        }
    }, [
        appliedFacets,
        facets,
        onFilterChange
    ]);
    const onFacetFilterClear = (0, _react.useCallback)(async (key, category)=>{
        const updatedValue = appliedFacets.map((facet)=>facet.key === category ? {
                ...facet,
                items: facet.items.map((item)=>item.value === key ? {
                        ...item,
                        selected: false
                    } : item)
            } : facet);
        setAppliedFacets(updatedValue);
        await onFilterChange(updatedValue);
        await onFilterApply(updatedValue);
    }, [
        appliedFacets,
        onFilterApply,
        onFilterChange,
        setAppliedFacets
    ]);
    return {
        onFilterApply,
        onFilterChange,
        onClear,
        selectedFacets,
        onFilterClose,
        onFacetFilterClear,
        filterValue: facets,
        appliedFacets,
        setAppliedFacets,
        loading: isLoading
    };
};
exports.useFilter = useFilter;
